 jQuery('.read-more.toggle').on('click', function() {
    jQuery(this).parents().children('.additional-description').slideToggle( function() {
        if(jQuery(this).is(':visible')) {
            jQuery(this).siblings('.read-more.toggle').addClass('less');
        }
        else {
            jQuery(this).siblings('.read-more.toggle').removeClass('less');
        } 
    });
});

 jQuery('.references3 .description .read-more').on('click', function() {
    const container = jQuery(this).parents('.person')
    container.find('.additional-description').slideToggle({
        start: function() {
            container.find('.description .read-more').toggle()
        },
        complete: function() {
            container.find('.additional-description-container .read-more').toggleClass('less');
        },
    });
});

jQuery('.references3 .additional-description-container .read-more').on('click', function() {
    const container = jQuery(this).parents('.person')
    container.find('.additional-description').slideToggle({
        start: function() {
            container.find('.additional-description-container .read-more').toggleClass('less');
        },
        complete: function() {
            container.find('.description .read-more').toggle()
        },
    });
});


/* 
Javascript of the reference block added here because references.js doesn't work for unknown reason. 
Can be moved when problem solved.
*/

// Open the video popup when clicking the image
jQuery('.reference-video').on('click', function() {
    var popup_container = jQuery(this).find('.popup-container').html();
    if(jQuery('#page_darkening').length > 0) {
        // popup element exists, replace content
        jQuery('#page_darkening .popup-container').html(popup_container);
    } else {
        // popup element doesn't exist, create new
        jQuery('body').append('<div id="page_darkening"><div id="video_popup"><div id="close">X</div><div class="popup-container">' + popup_container + '</div></div></div>');
    }
    
    jQuery('#video_popup').css('display','flex');
    jQuery('#page_darkening').css('display','flex');
});

// When the user clicks anywhere outside of the popup, close the window
jQuery(document).on('click','#page_darkening', function(e) {
    jQuery('#page_darkening').hide();
    jQuery('#video_popup').hide();
});

// When the user clicks the popup close button close the window
jQuery(document).on('click','#close', function(e) {
    jQuery('#page_darkening').hide();
    jQuery('#video_popup').hide();
});